import { isNil } from 'lodash';
import { ReactNode } from 'react';
import { FieldLabel } from '@shared/components/FieldLabel';
import { Icon, toIconName } from '@shared/components/Icon';
import { Text } from '@shared/components/Text';
import { View } from '@shared/components/View';
import { API } from '@shared/types/api';
import { isInputComponent } from '../../utils';
import classNames from './WorkflowComponentWrapper.module.css';

interface Props {
  children: ReactNode;
  extraChildren?: ReactNode;
  paddingHorizontal?: number;
  iconPad?: number;
  component: API.AnyComponent;
  showLabel?: boolean;
  showIcon?: boolean;
  error?: string;
}

export function WorkflowComponentWrapper({
  children,
  extraChildren,
  paddingHorizontal,
  iconPad = 0,
  component,
  showLabel,
  showIcon = true,
  error,
}: Props) {
  const hasError = !isNil(error);

  if (!isInputComponent(component)) {
    return null;
  }

  return (
    <View className={[classNames.workflowComponentWrapper, hasError && classNames.hasError]}>
      <View paddingHorizontal={paddingHorizontal} fullWidth>
        <View row centerVertically className={classNames.content}>
          {!isNil(component.icon) && showIcon && (
            <View paddingRight={iconPad} className={classNames.iconContainer}>
              <Icon className={classNames.icon} name={toIconName(component.icon)} gridSize={5} />
            </View>
          )}
          <View className={classNames.field}>
            {showLabel && (
              <View>
                <FieldLabel label={component.label} />
              </View>
            )}
            {children}
          </View>
        </View>
        {extraChildren && (
          <View paddingLeft={showIcon ? 40 / 8 + iconPad : 0}>{extraChildren}</View>
        )}
        {hasError && (
          <View className={classNames.error}>
            <Text size="body2" danger>
              {error}
            </Text>
          </View>
        )}
      </View>
    </View>
  );
}
